import { useState } from 'react'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { useNavigate, useOutletContext } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { createMissionData, fetchMissionDataTypesByGroup } from '@services/data.service'
import DrawModeToggles from '@App/components/DrawModeToggles/DrawModeToggles'
import DataFormTitle from '@App/components/DataFormTitle/DataFormTitle'
import TypeSelect from '@App/components/TypeSelect/TypeSelect'
import VisibilityToggles from '@App/components/VisibilityToggles/VisibilityToggles'

import EnvironmentData from '../EnvironmentData/EnvironmentData'

import './environment-form.styl'

function EnvironmentForm() {
  const navigate = useNavigate()
  const { map } = useOutletContext()
  const { activeProject } = useSelector(state => state.missionSetup)
  const queryClient = useQueryClient()
  const [name, setName] = useState('')
  const [description, setDescription] = useState('')
  const [enviromentType, setEnvironmentType] = useState()
  const [drawnFeature, setDrawnFeature] = useState(null)
  const [visibility, setVisibility] = useState('private')
  const [isSubmitting, setIsSubmitting] = useState(false)

  const { data: types } = useQuery({
    queryKey: ['types', 'env'],
    queryFn: () => fetchMissionDataTypesByGroup('env'),
  })

  const onSubmit = async (e) => {
    e.preventDefault()
    if (!activeProject?.id || !enviromentType || !drawnFeature) return

    setIsSubmitting(true)

    const selectedType = types?.find(type => type.id === enviromentType)
    const source = selectedType?.dataSource?.[0] || 'custom'
    const geometry = drawnFeature.geometry || drawnFeature

    try {
      await createMissionData({
        type: 'Feature',
        id: name,
        geometry,
        properties: {
          id: name,
          mission: activeProject.id,
          dataType: enviromentType,
          name,
          description,
          source,
          private: visibility === 'private',
        },
      })
      queryClient.invalidateQueries({
        queryKey: ['env', activeProject.id],
        exact: false,
      })
      navigate(-1)
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <form
      className={`environment-form${isSubmitting ? ' environment-form--loading' : ''}`}
      onSubmit={onSubmit}
    >
      <DataFormTitle>Name</DataFormTitle>
      <div className="environment-form__input-field">
        <input type="text" value={name} onChange={e => setName(e.target.value)} />
      </div>
      <DataFormTitle>Description</DataFormTitle>
      <div className="environment-form__input-field">
        <textarea value={description} onChange={e => setDescription(e.target.value)} />
      </div>
      <DataFormTitle>Select data type</DataFormTitle>
      <div className="environment-form__input-field">
        <TypeSelect
          value={enviromentType}
          onChange={setEnvironmentType}
          types={types}
          iconBasePath="/img/icons/types/env"
        />
      </div>
      <DataFormTitle>Data location</DataFormTitle>
      <div className="environment-form__input-field">
        <DrawModeToggles
          drawModes={types && types.find(t => t.id === enviromentType)?.drawMode}
          onDraw={setDrawnFeature}
          map={map}
        />
      </div>
      <DataFormTitle>Visibility</DataFormTitle>
      <VisibilityToggles
        value={visibility}
        onChange={setVisibility}
      />
      <button
        className="environment-form__submit"
        type="submit"
        disabled={!name || !enviromentType || !drawnFeature || isSubmitting}
      >
        {isSubmitting ? 'Submitting…' : 'Submit'}
      </button>
      <EnvironmentData passive={true} />
    </form>
  )
}

export default EnvironmentForm
